import { render, staticRenderFns } from "./RolesColorPickerBtn.vue?vue&type=template&id=7236ba0a&scoped=true&"
import script from "./RolesColorPickerBtn.vue?vue&type=script&lang=js&"
export * from "./RolesColorPickerBtn.vue?vue&type=script&lang=js&"
import style0 from "./RolesColorPickerBtn.vue?vue&type=style&index=0&id=7236ba0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7236ba0a",
  null
  
)

export default component.exports